import * as React from 'react';
import { CurrentUserGq } from '../../graphql/users/models/CurrentUserGq';

export interface SleekContextValues {
  sleekOpen: boolean;
  toggleSleek: () => void;
  openFeedback: () => void;
  setUser: (user: CurrentUserGq) => void;
}

export const SleekContext = React.createContext<SleekContextValues>({
  sleekOpen: false,
  toggleSleek: () => {},
  setUser: (user) => {},
  openFeedback: () => {},
});
